import { useSelector } from "react-redux";
import { CanvasChildrenProps } from "../../../components/Canvas/CanvasContainer";
import { selectRangeWithUnits, selectStepCount } from "../../../store/freq-analysis/selectors";
import { extractNumber, extractUnits } from "../../../helpers/converters/units";
import { floatToString } from "../../../helpers/math";

type CanvasVerticalDividerProps = {} & CanvasChildrenProps;

const CanvasVerticalDividerList = ({ containerHeight, containerWidth }: CanvasVerticalDividerProps) => {
  const dividerAmount = useSelector(selectStepCount);
  const range = useSelector(selectRangeWithUnits);
  const from = extractNumber(range[0]);
  const to = extractNumber(range[1]);
  const units = extractUnits(range[0]);

  if (!containerWidth || !dividerAmount) {
    return null;
  }

  const step = (to - from) / dividerAmount;
  const pxInStep = containerWidth / dividerAmount;

  return (
    <g className={'vertical-divider-list'} textAnchor="middle" fontSize={10}>
      {
        new Array(dividerAmount + 1).fill(1).map((_, index) => {
          const frequency = from + step * index;
          return (index === 0 || index === dividerAmount) ? null : (
            <g className="tick" key={frequency} opacity="1" transform={`translate(${index * pxInStep}, 0)`}>
              <line stroke="currentColor" y1={0} y2={containerHeight} strokeDasharray="2,2" color="gray"></line>
              <text fill="currentColor" y="5" dy="0.71em">{floatToString(frequency)} {units}</text>
            </g>
          )
        })
      }
    </g>
  );
}

export default CanvasVerticalDividerList;